module.exports = __webpack_public_path__ + "KaTeX_SansSerif-Bold.30a61437.woff";